import { createContext, type PropsWithChildren, useContext, useMemo } from 'react'

import { useGetEmployersRenewalsRenewalConfigsId as useGetRenewalConfig } from 'utils/web_api'
import { type EmployersRenewalsRenewalConfig as RenewalConfig } from 'utils/web_api.schemas'

export type EmployerRenewalConfigProviderProps = {
  renewalConfigId: string
}

type EmployerRenewalConfigContextType = {
  renewalConfigId: string
  employerRenewalConfig?: RenewalConfig
  isLoading: boolean
  isError?: boolean
  refetch: () => void
  isUsingFlatAllowances?: boolean
}

const EmployerRenewalConfigContext = createContext<EmployerRenewalConfigContextType>({
  renewalConfigId: '',
  isLoading: false,
  refetch: () => {},
})

export function useEmployerRenewalConfig () {
  return useContext(EmployerRenewalConfigContext)
}

export default function EmployerRenewalConfigProvider ({
  renewalConfigId,
  children,
}: PropsWithChildren<EmployerRenewalConfigProviderProps>) {
  const { data: renewalConfig, isLoading, isError, refetch } = useGetRenewalConfig(renewalConfigId)

  const isUsingFlatAllowances = useMemo(() => {
    return renewalConfig?.current_year_quote?.has_flat_allowances
  }, [renewalConfig])

  return (
    <EmployerRenewalConfigContext.Provider
      value={{
        renewalConfigId,
        employerRenewalConfig: renewalConfig,
        isLoading,
        isError,
        refetch,
        isUsingFlatAllowances,
      }}
    >
      {children}
    </EmployerRenewalConfigContext.Provider>
  )
}
